import { createSelector } from 'reselect';
import { RootState } from 'src/store';

const getDocuments = (state: RootState) => state.pages.editor.documents.present;

const getAllDocuments = createSelector([getDocuments], (documents) => documents);

export default getAllDocuments;
